import CountryForm from '../../components/CountryForm/CountryForm';
import { UPDATE_COUNTRY } from '../../constants';

function CountryEdit() {
  return <CountryForm type={UPDATE_COUNTRY} />;
}

export default CountryEdit;
